<h1 mat-mdc-dialog-title class="center">Validation du panier</h1>
<div mat-dialog-content>
  <p>Etes-vous certain de valider ce panier ?</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="refuse()" color="white">Annuler</button>
  <button mat-raised-button (click)="accept()" cdkFocusInitial color="primary">Oui</button>
</div>